import { Pipe, PipeTransform } from '@angular/core';
import { ColorUtils } from '../../core/utils/ColorUtils';

@Pipe({
  name: 'avatarColor',
  standalone: true
})
export class AvatarColorPipe implements PipeTransform {

  public transform(val: string): string {
    return ColorUtils.getInitialsColor(val);
  }
}
